// TODO: Move content to static
const SET_PRODUCTS = 'SET_PRODUCTS'

export const state = () => ({
  products: []
})

function sortByProductOrder(products, productOrder = []) {
  const newProducts = products.map(product => {
    const [id, order] = productOrder.find(arr => arr[0] === product.id) || []

    if (id) product.displayOrder = order

    return product
  })

  return newProducts.sort((a, b) => (a.displayOrder > b.displayOrder ? -1 : 1))
}

export const actions = {
  async getProducts({ commit, state }) {
    if (!state.products.length) {
      const response = await import('~~/.cache/products.json')

      commit(SET_PRODUCTS, response.default)
    }
  }
}

export const mutations = {
  [SET_PRODUCTS](state, payload) {
    state.products = payload
  }
}

export const getters = {
  published(state) {
    return state.products.filter(i => i.isPublished)
  },

  products(state) {
    return state.products.filter(i => ['original', 'variant'].includes(i.type))
  },

  samples(state, getters, rootState, rootGetters) {
    const sampleInBag = rootGetters['cart/sampleInBag']
    const samples = [...getters.published]
      .filter(
        item =>
          item.isSample && !(item.isOutOfStock || item.stockStatus === 'low')
      )
      .sort((a, b) => a.displayOrder - b.displayOrder)

    if (sampleInBag) {
      return samples.sort((a, b) => (b.id === sampleInBag.id ? 1 : -1))
    }

    return samples
  },

  sortedSamples(state, getters, rootState) {
    const { productOrder = [] } = rootState.user
    const samples = getters.published.filter(
      item => item.isSample && item.stockStatus !== 'low'
    )

    if (!Array.isArray(productOrder) || !productOrder.length) {
      return samples
    }

    return [...samples]
      .map(product => {
        const [id, order] =
          productOrder.find(arr => arr[0] === product.og_product_id) || []

        if (id) {
          product.displayOrder = order
        }

        return product
      })
      .sort((a, b) => (a.displayOrder > b.displayOrder ? -1 : 1))
  },

  sortedProducts(state, getters, rootState) {
    const { productOrder = [] } = rootState.user

    return !Array.isArray(productOrder) || !productOrder.length
      ? getters.products
      : sortByProductOrder(getters.products, productOrder)
  },

  productsInBag(_, getters, rootState) {
    return getters.sortedProducts.filter(i =>
      rootState.cart.items.find(item => item.id === i.id)
    )
  },

  productsNotInBag(_, getters, rootState) {
    return getters.sortedProducts.filter(
      i => !rootState.cart.items.find(cartItem => cartItem.id === i.id)
    )
  },

  getItem(state) {
    return function (productId) {
      return state.products.find(item => item.id == productId)
    }
  },

  isLimitedStock(state, getters, rootState, rootGetters) {
    return function (productId) {
      const product = rootGetters['products/getItem'](productId)

      return product.stockStatus === 'limited'
    }
  }
}
